<app-page-header title="Guest details"></app-page-header>
<div class="row">
  <div class="col-md-4">
    <app-guest-general-info [data]="generalDetails"></app-guest-general-info>
  </div>

  <div class="col-md-4">
    <app-guest-account [data]="accountInfo"></app-guest-account>
  </div>

  <div class="col-md-4">
    <app-guest-trip-route-details [data]="generalDetails"></app-guest-trip-route-details>
  </div>
</div> 

<div class="height-15"></div>

<div class="height-15"></div>

<div class="height-15"></div>

<div class="row">
  <div class="col">
    <app-guest-order-details *ngIf="toggleableDetails === 'Order Details'" class="width-100" [customerMobile]="mobileNumber" [customerId]="id" [guestDetailsToggleableHeaders] ="guestDetailsToggleableHeaders"
       (toggleHeaders)="headersToggled($event)"></app-guest-order-details>
    <app-guest-wallet-transactions *ngIf="toggleableDetails === 'Wallet Transactions'" class="width-100" [profileId]="id" [guestDetailsToggleableHeaders]="guestDetailsToggleableHeaders"
       (toggleHeaders)="headersToggled($event)"></app-guest-wallet-transactions>
    <app-guest-referral-rewards *ngIf="toggleableDetails === 'Referral Rewards'" class="width-100" [profileId]="id" [guestDetailsToggleableHeaders]="guestDetailsToggleableHeaders"
       (toggleHeaders)="headersToggled($event)"></app-guest-referral-rewards>
  </div>
</div> 